import { request } from '../axios/request';

import {
  FETCH_PACKAGES_PENDING,
  FETCH_PACKAGES_REJECTED,
  FETCH_PACKAGES_FULFILLED,
} from '../constants/packages';

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_PACKAGES_PENDING,
});

const rejected = (error) => ({
  type: FETCH_PACKAGES_REJECTED,
  error,
});

const fulfilled = (response) => ({
  type: FETCH_PACKAGES_FULFILLED,
  response,
});

export const fetchPackages = (orderNumber) => (dispatch) => {
  dispatch(pending());

  const url = OMS.OMS.PACKAGES.replace('{0}', orderNumber);
  request({ method: 'get', url })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected({ apiError: error }));
    });
};



// WEBPACK FOOTER //
// ./src/actions/packages.js